"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formError = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var mappers_1 = require("../mappers");
var formError = function (event) {
    var _a;
    return {
        event: "form-interaction",
        eventInfo: "form-interaction",
        form: __assign({ action: analytics_layer_1.FormInteractionEventNames.FormError }, (0, mappers_1.mapFormData)((_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.form))
    };
};
exports.formError = formError;
